module.exports = __webpack_public_path__ + "img/hair_back_female_wavy_long.a4371278.png";